import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function CounselorInfo({ showCard = true }) {
  const caseStatusState = useSelector(state => state?.ch31CaseStatusDetails);

  const caseManager = caseStatusState?.data?.attributes?.caseManager;

  if (!caseManager) return <></>;

  const name = [caseManager.firstName, caseManager.lastName]
    .filter(value => value?.trim())
    .join(' ');
  const phone = caseManager.phone?.trim() || 'Not available';
  const email = caseManager.email?.trim() || 'Not available';

  const content = (
    <div className={!showCard ? 'vads-u-margin-top--3' : ''}>
      <h3 className="vads-u-margin-top--1">Counselor contact information</h3>
      <p>
        Name: <strong>{name || 'Not available'}</strong>
      </p>
      <p>
        Phone number: <strong>{phone}</strong>
      </p>
      <p>
        Email: <strong>{email}</strong>
      </p>
    </div>
  );

  return showCard ? (
    <va-card
      icon-name=""
      class="vads-u-max-width--100"
      style={{
        width: 'fit-content',
        overflowWrap: 'anywhere',
      }}
    >
      {content}
    </va-card>
  ) : (
    content
  );
}

CounselorInfo.propTypes = {
  showCard: PropTypes.bool,
};
